import React from 'react';
import { Chip } from '@heroui/react';
import { Icon } from '@iconify/react';
import { StatisticsData } from '../types';

interface StatisticIncomeCellProps {
  statistic: StatisticsData;
}

const StatisticIncomeCell: React.FC<StatisticIncomeCellProps> = ({ statistic }) => {
  return (
    <div className="flex items-center gap-2">
      <span className="font-semibold">${statistic.incomeAmount.toFixed(2)}</span>
      <Chip
        size="sm"
        color={
          statistic.incomeChangeType === 'positive'
            ? 'success'
            : statistic.incomeChangeType === 'negative'
              ? 'danger'
              : 'default'
        }
        variant="flat"
        startContent={
          statistic.incomeChangeType === 'positive' ? (
            <Icon height={12} icon={'solar:arrow-right-up-linear'} width={12} />
          ) : statistic.incomeChangeType === 'negative' ? (
            <Icon height={12} icon={'solar:arrow-right-down-linear'} width={12} />
          ) : (
            <Icon height={12} icon={'solar:arrow-right-linear'} width={12} />
          )
        }
      >
        {statistic.incomeChange}
      </Chip>
    </div>
  );
};

export default StatisticIncomeCell;
